import { render, staticRenderFns } from "./dms-reference-type.vue?vue&type=template&id=3d266d82&"
import script from "./dms-reference-type.vue?vue&type=script&lang=js&"
export * from "./dms-reference-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports